import React from 'react';
import { fetchOffer, setStale } from '../../api/offers/actions'
import { getContractOfferPDF, customerNameById, customerByKennitala, allQuotesCalculated, formatKennitala, getDescriptiveContractName, checkIfVIDexists, offerErrorsByOfferType, offerErrors, getContractNameDetail } from '../../utils'
import Offer from '../offer'
import Nav from 'react-bootstrap/Nav'
import { isUserBroker } from '../../api/brokers/actions'

import Tab from 'react-bootstrap/Tab'

import { connect } from 'react-redux'
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import Alert from 'react-bootstrap/Alert'

import { SvgArrowIcon, SvgCheckIcon, SvgCloseIcon } from '../svg';
import ErrorBoundary from '../error-boundary';

const _defaultChecks = () => {
    return {
        "VID": false,
        "VIDT": false,
        "REN": false,
        "RISLEB": false,
        "RIS": false,
        "KSP": false,
        "LEB": false
    }
}

class Quote extends React.Component {

    constructor(props) {
        super(props)
        
        this.state = {
            showErrorIcon: false,
            once: true,
        }
        this.getPDF = this.getPDF.bind(this)

    }

    componentDidMount() {
        const { offers, infoCollection } = this.props
        if (offers && offers.isStale && Object.keys(offers.offerQueryParameters).length > 0) {
            for (var kennitala of Object.keys(offers.offerQueryParameters)) {
                for (var offerType of Object.keys(offers.offerQueryParameters[kennitala])) {
                    if (offers.offerQueryParameters[kennitala][offerType] === true) {
                        let originalOfferType = offerType
                        if (offerType === "FOR") {
                            offerType = "REN"
                        }
                        let info = {}
                        Object.entries(infoCollection.data).map(([k, v]) => {
                            if (k === kennitala) {
                                Object.entries(v).map(([a, b]) => {
                                    if (a.includes(offerType)) {
                                        info[a] = b
                                    }
                                })
                            }
                        })
                        let data = {
                            customerId: kennitala,
                            type: originalOfferType,
                            information: info,
                            gender: infoCollection.data[kennitala].gender,
                        }
                        if (infoCollection.data[kennitala].occupation) {
                            data.occupation = infoCollection.data[kennitala].occupation
                        }
                        if (infoCollection.data[kennitala].smokerstatus) {
                            data.smokerstatus = infoCollection.data[kennitala].smokerstatus
                        }
                        if (infoCollection.data[kennitala].education) {
                            data.education = infoCollection.data[kennitala].education
                        }
                        this.props.dispatch(fetchOffer(data))

                    }
                }

            }
        }

        this.props.dispatch(isUserBroker());
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
      let checks = []
      if(this.props.offers.isStale) {
        if (Object.keys(this.props.offers.offers).length > 0 && offerErrors(this.props)) {
          checks.push(false)
        } else {checks.push(true)}
        if (checks.every((v) => v === true)) {
          this.props.dispatch(setStale(false))
        }
      }
    }

    onNavLinkClick(e) {
        var tab = $(e.target).parents('.nav-item').prev('.nav-item');

        $('.tabs .nav-item').removeClass('no-border');
        tab.addClass('no-border');
    }

    getDefaultActiveKey(customerId) {
        let selectedContracts = Object.keys(this.props.offers.offerQueryParameters[customerId])
            .filter((off) => this.props.offers.offerQueryParameters[customerId][off] === true)

        return selectedContracts[0]
    }

    getPDF(customerId, offerType) {
        let data = Object.assign({}, this.props.offers)
        data = Object.assign(data, this.props.customers)
        data.infoCollection = this.props.infoCollection
        data.physical_signing = false
        data.euro_value = this.props.gui.currency
        let insuranceTakers = Object.assign({}, this.props.insuranceTakers)
        data.insuranceTakers = insuranceTakers
        let nationalRegistry = Object.assign({}, this.props.nationalRegistry)
        data.nationalRegistry = nationalRegistry
        data.customer_id = customerId,
        data.offer_type = offerType


        getContractOfferPDF(data)

    }  

    onNavLinkClick(e) {
        var tab = $(e.target).parents('.nav-item').prev('.nav-item');

        $('.step .nav-item').removeClass('no-border');
        tab.addClass('no-border');
    }

    render() {

        const { customers, brokers, offers } = this.props

        let checks = {}

        if (offers && Object.keys(offers.offerQueryParameters).length > 0) {
            for (var kennitala of Object.keys(offers.offerQueryParameters)) {
                if (!Object.keys(checks).includes(kennitala)) {
                    checks[kennitala] = _defaultChecks()
                }

                Object.entries(offerErrorsByOfferType(this.props, kennitala)).forEach(([key, val]) =>{
                    checks[kennitala][key] = val
                })
                
                checks[kennitala]["VID"] = checks[kennitala]["VID"] || checkIfVIDexists('VID', this.props, kennitala)
                checks[kennitala]["VIDT"] = checks[kennitala]["VIDT"] || checkIfVIDexists('VIDT', this.props, kennitala)
            }
        }

        return (
            <ErrorBoundary>

                <div className="row justify-content-center xs-pt-10">
                    <div className="col-12 col-sm-10 col-md-8">
                        <div className="row justify-content-center xs-pt-10 step">

                            <Tab.Container defaultActiveKey={Object.keys(this.props.offers.offerQueryParameters)[0]} >
                                <div className="tabs-container">
                                    <Nav variant="tabs" className="tabs">
                                        {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>
                                            <Nav.Item key={customerId} className="check">
                                                <Nav.Link eventKey={customerId} onClick={this.onNavLinkClick.bind(this)}>
                                                    {/* <Nav.Link eventKey={customerId}> */}
                                                    {customerNameById(customerId, this.props.customers)}<span>({formatKennitala(customerId)})</span>
                                                </Nav.Link>
                                                { allQuotesCalculated(this.props, customerId) &&
                                                    <span className="check-icon small blue">
                                                        <SvgCheckIcon />
                                                    </span>
                                                }
                                            </Nav.Item>
                                        )}
                                    </Nav>
                                </div>


                                <Tab.Content className="w-100">
                                    {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>

                                        <Tab.Pane key={customerId} eventKey={customerId}>
                                            <Accordion defaultActiveKey={customerId+"-0"}>

                                                {Object.keys(this.props.offers.offerQueryParameters[customerId]).filter((off) => this.props.offers.offerQueryParameters[customerId][off] === true).map((productCode, idx) =>
                                                    <Card key={`${customerId}-${productCode}`}>
                                                        <Card.Header>

                                                            <Accordion.Toggle as={Button} variant="link" eventKey={`${customerId}-${idx}`} className="toggle-button">
                                                                {getDescriptiveContractName(productCode)}
                                                                {getContractNameDetail(this.props.infoCollection, customerId, productCode)}

                                                                { this.props.offers.offers[customerId] && this.props.offers.offers[customerId][productCode] && !this.props.offers.offers[customerId][productCode].isFetching && !this.props.offers.offers[customerId][productCode].error &&
                                                                    <span className="check">
                                                                        <span className="check check-icon big green">
                                                                            <SvgCheckIcon />
                                                                        </span>    
                                                                    </span>
                                                                } 
                                                                { checks[customerId][productCode] && 
                                                                    <span className="check">
                                                                        <span className="check check-icon big red">
                                                                            <SvgCloseIcon />
                                                                        </span>    
                                                                    </span>
                                                                }

                                                                <span className="arrow-toggle-button">
                                                                    <SvgArrowIcon />
                                                                </span>
                                                            </Accordion.Toggle>


                                                            {this.props.offers.offers[customerId] && this.props.offers.offers[customerId][productCode] && !this.props.offers.offers[customerId][productCode].isFetching && !this.props.offers.offers[customerId][productCode].error &&
                                                                <span className="actions mr-5" style={{position: 'absolute', right: '15px', top: 'calc(50% - 31px)'}}>
                                                                    <button className="btn btn-primary xs-m-10 mr-5" onClick={(e) => {e.preventDefault();this.getPDF(customerId, productCode)}}>Sækja PDF</button> 
                                                                </span>
                                                            }

                                                        </Card.Header>
                                                        <Accordion.Collapse eventKey={`${customerId}-${idx}`}>
                                                            <Card.Body>
                                                                {this.props.offers.offers[customerId] !== undefined && Object.keys(this.props.offers.offers[customerId]).map((offerType, i) =>
                                                                    ((offerType === productCode) || offerType === "REN" && productCode === "FOR") && 
                                                                    <React.Fragment key={offerType}>
                                                                        <Offer offer={this.props.offers.offers[customerId]} offerType={offerType} customer={customerByKennitala(customerId, customers)} dispatch={this.props.dispatch} currencyExchange={this.props.gui.currency} infoCollection={this.props.infoCollection.data[customerId]} />
                                                                        <>
                                                                            {this.props.offers.offers[customerId] && this.props.offers.offers[customerId][offerType] && !this.props.offers.offers[customerId][offerType].isFetching && !this.props.offers.offers[customerId][offerType].error &&
                                                                                <button className="btn btn-primary xs-m-10" onClick={() => this.getPDF(customerId, productCode)}>Sækja PDF</button> 
                                                                            }
                                                                        </>
                                                                    </React.Fragment>
                                                                )}
                                                                
                                                            </Card.Body>
                                                        </Accordion.Collapse>
                                                    </Card>
                                                )}

                                            </Accordion>
                                        </Tab.Pane>

                                    )}
                                </Tab.Content>
                            </Tab.Container>

                            {Object.keys(this.props.offers.offerQueryParameters).map((customerId, idx) =>
                                <React.Fragment key={customerId}>
                                    {Object.keys(this.props.offers.offerQueryParameters[customerId]).filter((off) => this.props.offers.offerQueryParameters[customerId][off] === true).map((productCode, idx) =>
                                        <React.Fragment key={`${customerId}-${productCode}`}>
                                        {/* { this.props.offers.offers[customerId] !== undefined && checkIfVIDexists(this.props, customerId, 'VIDT') && productCode === "VID" && */}
                                        { this.props.offers.offers[customerId] !== undefined && checkIfVIDexists(productCode, this.props, customerId) &&
                                                <Alert variant="warning">
                                                    Ekki er hægt að halda áfram í samningsgerð á {getDescriptiveContractName(productCode)} fyrir {customerNameById(customerId, this.props.customers)} ({formatKennitala(customerId)}) þar sem viðkomandi er nú þegar með samning hjá Allianz
                                                </Alert>
                                            }
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            )}

                            {brokers && brokers.data === false && !(offers && offers.isFetching || customers && customers.isFetching) &&
                                <Alert variant="warning">
                                    Þú ert ekki skráður sem ráðgjafi hjá Allianz og hefur ekki rétt á því að skila inn samning. Ef þú telur þetta vera mistök getur þú haft samband við skrifstofu Allianz í 595-3300 eða á allianz@allianz.is.
                                </Alert>
                            }                            
                        </div>
                    </div>
                </div>
            </ErrorBoundary>
        )
    }
}


Quote.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        customers: {},
        offers: {},
        gui: {},
        currency: {},
        infoCollection: {},
        brokers: {},
        insuranceTakers: {},
        nationalRegistry: {},
    }
    f.customers = (state.customers === undefined) ? {} : state.customers
    f.offers = (state.offers === undefined) ? {} : state.offers
    f.gui = (state.gui === undefined) ? {} : state.gui
    f.currency = (state.currency === undefined) ? {} : state.currency
    f.infoCollection = (state.infoCollection === undefined) ? {} : state.infoCollection
    f.brokers = (state.brokers === undefined) ? {} : state.brokers
    f.insuranceTakers = (state.insuranceTakers === undefined) ? {} : state.insuranceTakers
    f.nationalRegistry = (state.nationalRegistry === undefined) ? {} : state.nationalRegistry

    return f;
}

export default connect(mapStateToProps)(Quote);